/**
 * @generated SignedSource<<57eb25225fe017f9d6913bef17169cb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubTaskResults_lastToolCall$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ToolCallButton_toolCall" | "ToolCallSheet_toolCall">;
  readonly " $fragmentType": "SubTaskResults_lastToolCall";
};
export type SubTaskResults_lastToolCall$key = {
  readonly " $data"?: SubTaskResults_lastToolCall$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubTaskResults_lastToolCall">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubTaskResults_lastToolCall",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToolCallButton_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToolCallSheet_toolCall"
    }
  ],
  "type": "GraphQLMessageToolCall",
  "abstractKey": null
};

(node as any).hash = "206019fda4381566619856cae1c49cf6";

export default node;
